/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { NumberTypes } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { buildNumberColumn, GridOptionsExt, ManualGridDefinition } from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { HpeCcOrderDetailsItem } from '../../../resources/hpe-details.model';

@Injectable()
export class HpeOrderDetailsGridDefinition extends ManualGridDefinition {
  constructor(private translationService: TranslationService) {
    super();
  }

  buildGridOptions(): GridOptionsExt {
    return {
      defaultColDef: {
        sortable: false,
      },
      getRowNodeAutomationId: (data: HpeCcOrderDetailsItem) => data.code,
    };
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'code',
      headerName: this.translationService.get('lbl_code'),
      width: 250,
    }, {
      field: 'cost',
      headerName: this.translationService.get('lbl_cost_dollar'),
      width: 150,
      ...buildNumberColumn(NumberTypes.Price),
    }, {
      field: 'quantity',
      headerName: this.translationService.get('lbl_qty'),
      width: 125,
      ...buildNumberColumn(NumberTypes.SignedQuantity_2),
    }, {
      field: 'extension',
      headerName: this.translationService.get('lbl_extension_dollar'),
      width: 100,
      ...buildNumberColumn(NumberTypes.Price),
    }];
  }
}
